export default __webpack_public_path__ + "static/media/salicornio.44ab6474.png";